import type { ChartRow } from "../types";
import { humanizeColumn } from "./_humanize";
import { axisStyle, axisTooltip, baseLayout, columnIndex, pluck, valueAxisStyle } from "./_shared";

interface Input {
  y: string;
  x_series: string[];
}

export function buildHorizontalBar(
  input: Input,
  rows: ChartRow[],
  columns: string[],
  _title: string,
  palette: ReadonlyArray<string>,
) {
  const yIdx = columnIndex(columns, input.y);
  // Reverse so the largest value lands at the top of the chart, which
  // is the natural "ranked" reading order.
  const categories = pluck(rows, yIdx)
    .map((v) => (v == null ? "—" : String(v)))
    .reverse();

  const series = input.x_series.map((name) => {
    const idx = columnIndex(columns, name);
    return {
      name: humanizeColumn(name),
      type: "bar" as const,
      data: pluck(rows, idx).slice().reverse(),
      barMaxWidth: 22,
      itemStyle: { borderRadius: [0, 4, 4, 0] },
    };
  });

  return {
    ...baseLayout(),
    tooltip: axisTooltip(undefined, input.x_series),
    color: [...palette],
    xAxis: { ...valueAxisStyle(input.x_series[0]), type: "value" as const, splitNumber: 5 },
    yAxis: {
      ...axisStyle,
      type: "category" as const,
      data: categories,
      axisLabel: { ...axisStyle.axisLabel },
    },
    series,
  };
}
